import * as v from 'valibot'
import client from '@shared/utils/client-rest'
import {
	getApplyCoordinationSettingsAcrossSettingsResponseSchema,
	getApplyPhaseSettingsAcrossSettingsResponseSchema,
	getApplySequencesAcrossSettingsResponseSchema,
	getApplyTodsAcrossSignalsResponseSchema,
	getApplyControllerSettingsAcrossSettingsResponseSchema,
	type getOptimusTmsSequenceSchema,
	type getOptimusTmsCoordinationSettingsSchema,
	type getOptimusTmsPhaseSettingsSchema,
	type getOptimusTmsTodSchema,
	type getOptimusTmsControllerSettingsSchema,
	type getOptimusTmsPhaseMappingSchema,
	type getTmsAtomicMovementSchema,
	type getTmsPhaseMappingItemSchema,
} from '../../../shared-schemas/optimus/optimus-config'

export type ITmsTimeOfDay = v.InferOutput<ReturnType<typeof getOptimusTmsTodSchema>>

export type ITmsCoordinationSettings = v.InferOutput<ReturnType<typeof getOptimusTmsCoordinationSettingsSchema>>

export type ITmsPhaseSettings = v.InferOutput<ReturnType<typeof getOptimusTmsPhaseSettingsSchema>>

export type ITmsSequence = v.InferOutput<ReturnType<typeof getOptimusTmsSequenceSchema>>

export type ITmsControllerSetting = v.InferOutput<ReturnType<typeof getOptimusTmsControllerSettingsSchema>>

export type IPhaseMappingData = v.InferOutput<ReturnType<typeof getOptimusTmsPhaseMappingSchema>>

export type IPhaseMapping = v.InferOutput<ReturnType<typeof getTmsPhaseMappingItemSchema>>

export type IAtomicMovement = v.InferOutput<ReturnType<typeof getTmsAtomicMovementSchema>>

export const OptimusConfigRequestKeys = {}

export function applyTodsAcrossSignalsFn(new_tods: ITmsTimeOfDay[], signals: string[]) {
	if (!new_tods) {
		throw new Error('Apply TODs to Multiple Signals: New TOD cannot be missing or empty')
	}
	if (!signals || !signals.length) {
		throw new Error('Apply TODs to Multiple Signals: Signals cannot be missing or empty')
	}

	return client(`/api/v1/pages/tms/time-of-days/apply-to-multiple-signals`, {
		method: 'PUT',
		body: {
			tod_references: new_tods,
			target_signal_ids: signals,
		},
	}).then((data) => v.parse(getApplyTodsAcrossSignalsResponseSchema({ expected_format: 'short' }), data))
}

export function applyCoordinationSettingsAcrossSignalsFn(
	new_coordination_settings: ITmsCoordinationSettings[],
	signals: string[],
) {
	if (!new_coordination_settings) {
		throw new Error('Apply TODs to Multiple Signals: New TOD cannot be missing or empty')
	}
	if (!signals || !signals.length) {
		throw new Error('Apply TODs to Multiple Signals: Signals cannot be missing or empty')
	}

	return client(`/api/v1/pages/tms/coordination-settings/apply-to-multiple-signals`, {
		method: 'PUT',
		body: {
			coordination_setting_references: new_coordination_settings,
			target_signal_ids: signals,
		},
	}).then((data) =>
		v.parse(getApplyCoordinationSettingsAcrossSettingsResponseSchema({ expected_format: 'short' }), data),
	)
}

export function applyPhaseSettingsAcrossSignalsFn(new_phase_settings: ITmsPhaseSettings[], signals: string[]) {
	if (!new_phase_settings) {
		throw new Error('Apply TODs to Multiple Signals: New TOD cannot be missing or empty')
	}
	if (!signals || !signals.length) {
		throw new Error('Apply TODs to Multiple Signals: Signals cannot be missing or empty')
	}

	return client(`/api/v1/pages/tms/phase-settings/apply-to-multiple-signals`, {
		method: 'PUT',
		body: {
			phase_setting_references: new_phase_settings,
			target_signal_ids: signals,
		},
	}).then((data) => v.parse(getApplyPhaseSettingsAcrossSettingsResponseSchema({ expected_format: 'short' }), data))
}

export function applySequencesAcrossSignalsFn(new_sequences: ITmsSequence[], signals: string[]) {
	if (!new_sequences) {
		throw new Error('Apply TODs to Multiple Signals: New TOD cannot be missing or empty')
	}
	if (!signals || !signals.length) {
		throw new Error('Apply TODs to Multiple Signals: Signals cannot be missing or empty')
	}

	return client(`/api/v1/pages/tms/sequences/apply-to-multiple-signals`, {
		method: 'PUT',
		body: {
			sequence_references: new_sequences,
			target_signal_ids: signals,
		},
	}).then((data) => v.parse(getApplySequencesAcrossSettingsResponseSchema({ expected_format: 'short' }), data))
}

export function applyControllerSettingsAcrossSignalsFn(
	new_controller_settings: ITmsControllerSetting[],
	signals: string[],
) {
	if (!new_controller_settings) {
		throw new Error('Apply TODs to Multiple Signals: New TOD cannot be missing or empty')
	}
	if (!signals || !signals.length) {
		throw new Error('Apply TODs to Multiple Signals: Signals cannot be missing or empty')
	}

	return client(`/api/v1/pages/tms/controller-settings/apply-to-multiple-signals`, {
		method: 'PUT',
		body: {
			controller_setting_references: new_controller_settings,
			target_signal_ids: signals,
		},
	}).then((data) => v.parse(getApplyControllerSettingsAcrossSettingsResponseSchema({ expected_format: 'short' }), data))
}
